// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BranchesOutlinedSvg from "@ant-design/icons-svg/es/asn/BranchesOutlined";
import AntdIcon from '../components/AntdIcon';

var BranchesOutlined = function BranchesOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BranchesOutlinedSvg
  }));
};

BranchesOutlined.displayName = 'BranchesOutlined';
export default React.forwardRef(BranchesOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BranchesOutlined.js
// module id = 681
// module chunks = 0